import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './FloatingCTA.css';

function FloatingCTA() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e) => {
    e.preventDefault();
    if (location.pathname === '/') {
      document.getElementById('cta-section')?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/#cta-section');
    }
  };

  return (
    <a
      href="/#cta-section"
      onClick={handleClick}
      className="floating-cta-new"
      data-testid="floating-rocket"
      title="Finde deinen persönlichen Förderer"
    >
      <div className="cta-icon">
        🚀
      </div>
    </a>
  );
}

export default FloatingCTA;
